import clsx from 'clsx';

import { generateClasses } from '../../../utils/helpers';
import FormulaIcon from '../../icons/FormulaIcon';
import CreateFormulaOverlay, {
  Props as CreateFormulaOverlayProps,
} from '../../plugins/formula/CreateFormulaOverlay';
import ToolBarButton, { Props as ToolBarButtonProps } from '../../ToolBarButton';
import useInsertFormulaButtonVM, { Props as VMProps } from './vm';

const insertFormulaButtonClasses = generateClasses('InsertFormulaButton', [
  'toolbarButton',
  'formula',
  'toolbarIcon',
  'formulaIcon',
]);

export type Props = VMProps &
  ToolBarButtonProps & {
    renderCreateFormulaOverlay: CreateFormulaOverlayProps['renderOverlay'];
    i18n?: CreateFormulaOverlayProps['i18n'] & { insert_formula?: string };
    classes?: Partial<typeof insertFormulaButtonClasses>;
    insertFormulaButtonId?: string;
    activeItemId?: string;
    isScreenReaderOn?: boolean;
  };

const InsertFormulaButton = ({
  renderCreateFormulaOverlay,
  i18n,
  classes,
  editorRef,
  insertFormulaButtonId,
  activeItemId,
  isScreenReaderOn,
  ...props
}: Props) => {
  const {
    showCreateFormulaOverlay,
    isCreateFormulaOverlayOpen,
    onInsertFormula: handleInsertFormula,
  } = useInsertFormulaButtonVM({ editorRef });
  return (
    <>
      <ToolBarButton
        id={insertFormulaButtonId}
        aria-label={i18n?.insert_formula}
        {...props}
        onClick={showCreateFormulaOverlay}
        className={clsx(
          insertFormulaButtonClasses.toolbarButton,
          classes?.toolbarButton,
          insertFormulaButtonClasses.formula,
          classes?.formula
        )}
        tabIndex={-1}
        aria-selected={insertFormulaButtonId === activeItemId}
      >
        <FormulaIcon
          fontSize="small"
          className={clsx(
            insertFormulaButtonClasses.toolbarIcon,
            classes?.toolbarIcon,
            insertFormulaButtonClasses.formulaIcon,
            classes?.formulaIcon
          )}
        />
      </ToolBarButton>
      <CreateFormulaOverlay
        isOpen={isCreateFormulaOverlayOpen}
        onClose={handleInsertFormula}
        editorRef={editorRef}
        renderOverlay={renderCreateFormulaOverlay}
        i18n={i18n}
        isScreenReaderOn={isScreenReaderOn}
      />
    </>
  );
};

export default InsertFormulaButton;
